import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import DigitizeImg from "../../images/location_new/fold5/img06.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Digitize(props) {
  return (
    <div className="digitize_sec p-100" style={{ backgroundColor: "#040404" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Growth-Enabling Software Development Company in Washington DC
            </h2>
            <p>
              As a leading software developer in Washington DC, we focus on
              experience-driven development, ensuring top-notch experiences for
              users. We deliver high-end, scalable, and sustainable technology
              solutions by leveraging Agile development methodology, fail-proof
              project management, and uninterrupted collaboration.
            </p>
            <p>
              We never compromise the quality of the solutions we build. We use
              legacy and modern quality assurance techniques to ensure that
              everything functions seamlessly and produces the ideal results to
              fix bugs and loopholes in the product before it gets deployed. We
              further use tools like Selenium, Katalon, J-Meter, and others to
              scrutinize the efficiency of the product and roll out a bug-free
              version of the software with impeccable design and user
              experience.
            </p>
            <Link
              style={{
                backgroundColor: "#fff",
                color: "#040404",
                border: "1px solid #040404",
              }}
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="digitize_img">
            <LazyLoadImage
              src={DigitizeImg}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Digitize;
